<template>
  <div>
    <div v-if="passwordUpdated">
      <h2 v-html="loc('components.changePassword.passwordUpdated')"></h2>
    </div>
    <div v-else>
      <v-form :fields="fields" :form-data="formData" :form-errors="formErrors">
        <div slot="buttons">
          <button :disabled="sendDisabled" v-on:click="send" type="submit" class="btn btn--white">{{loc('updatePassword')}}</button>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>

import VForm from './v-form.vue';

export default {
  components: {
    'v-form': VForm
  },
  name: 'ViewChangePassword',
  data: function () {
    return {
      formErrors: {},
      formData: {},
      passwordUpdated: false,
      token: null,
      sendDisabled: false,
      resetToken: '',
    }
  },
  computed: {
    fields() {
      return [{
        name: 'currentPassword',
        value: '',
        label: this.loc('currentPassword'),
        type: 'password'
      }, {
        name: 'newPassword',
        value: '',
        label: this.loc('newPassword'),
        type: 'password-strength',
      }, {
        name: 'newPasswordConfirm',
        value: '',
        label: this.loc('newPasswordAgain'),
        type: 'password'
      }];
    },
  },
  methods: {
    async send() {
      const self = this;

      this.sendDisabled = true;

      return this.$api.changePassword({
        currentPassword: this.formData.currentPassword,
        newPassword: this.formData.newPassword,
        newPasswordConfirm: this.formData.newPasswordConfirm
      })
      .then(res => {
        this.sendDisabled = false;

        // Errors in form
        if(res.code === 400) {
          this.formErrors = res.result.fields;
        }

        if(res.code === 200) {
          this.passwordUpdated = true;
        }
      });
    }
  }
}
</script>
